import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Box from '../Box'
import DocumentTitle from 'react-document-title'

import './index.scss'
import validateRouteProtocol from '../../utils/enforce-https'
import { appName } from '../../constants/constants'
import WithErrorBoundaryWrapper from 'components/WithErrorBoundaryWrapper/WithErrorBoundaryWrapper'
import config from '../../config'

/**
 * Login component
 */
class LoginPage extends Component {
  constructor(props) {
    super(props)
    validateRouteProtocol()
  }

  // The server does not carry redirectUrl through the SSO round-trip; the login saga reads it back on /sso-callback
  storeRedirectUrl = () => {
    try {
      const redirectUrl = new URLSearchParams(this.props.location?.search).get('redirectUrl')
      if (redirectUrl) {
        window.sessionStorage.setItem('ssoRedirectUrl', redirectUrl)
      } else {
        window.sessionStorage.removeItem('ssoRedirectUrl')
      }
    } catch (error) {
      // sessionStorage unavailable: the user lands on the default route after login
    }
  }

  render() {
    const ssoError = new URLSearchParams(this.props.location?.search).get('ssoError')

    return (
      <DocumentTitle title={this.props.documentTitle ? `${appName} | ${this.props.documentTitle}` : appName}>
        <Box className="authView alignItemsCenter justifyContentCenter loginPage">
          <Box className="authBox alignItemsCenter directionColumn">
            <>
              <h1 className="title">Your view of the digital consumer just got sharper</h1>
              {ssoError && (
                <div>
                  <div className="errorMessage">
                    There was a problem signing in with SSO. Please try again or contact your administrator.
                  </div>
                  <br />
                </div>
              )}

              <a
                id="sso-login-button"
                className="ssoButton"
                href={`${config.serverBaseUrl}/auth/oidc/login`}
                onClick={this.storeRedirectUrl}
              >
                Login with SSO
              </a>

              <div className="footer" />
            </>
          </Box>
        </Box>
      </DocumentTitle>
    )
  }
}

LoginPage.propTypes = {
  location: PropTypes.object,
  documentTitle: PropTypes.string
}

LoginPage.defaultProps = {
  documentTitle: 'Login'
}

export default WithErrorBoundaryWrapper(LoginPage, 'Login page')
